
<div class="flex flex-col p-4">

    <!-- Header -->
    <div class="flex flex-row justify-between">
        <h3 id="h-sd-finalise-ballot">Finalise Ballot</h3>
        <div class="flex items-start">
            <button class="material-symbols-rounded"
                (click)="close()">close</button>
        </div>
    </div>

    <!-- Form -->
    <form class="flex"
        [formGroup]="sdFinaliseBallotForm">
        <div class="flex flex-col mb-4">
            <!-- Checkbox -->
            <div class="flex flex-row items-start mb-4">
                <input id="sd-finalise-ballot-checkbox" 
                    type="checkbox"
                    class="mt-1 mr-2"
                    formControlName="confirmationCtrl" />
                <label
                    for="sd-finalise-ballot-checkbox"
                    class="body-default-regular text-black">
                    I have reviewed the ballot results and have taken all appropriate steps to resolve negative votes and considered all comments to achieve consensus.
                </label>
            </div>

            <label for="sd-finalise-ballot-comment" class="text-subtle body-large-regular">Final Comment
                <span class="body-large-regular text-red-500">*</span>
            </label>
            <app-text-area id="sd-finalise-ballot-comment"
                [displayCharactersCount]="false"
                formControlName="finalCommentCtrl"
            ></app-text-area>
        </div>
    </form>
    
    <!-- Buttons -->
     <div class="flex flex-row gap-4">
        <button class="btn btn-neutral border w-full" (click)="close()">Cancel</button>
        <button class="btn btn-primary w-full" 
            (click)="onFinaliseBallotClicked()"
            [disabled]="sdFinaliseBallotForm.invalid"
        >
            Finalise</button>
     </div>
    
</div>